import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { FC } from "react";
import { ReactComponent as WarningIcon } from "../../../../assets/images/warning-icon.svg";
import { MuiBox, MuiDoubleLabel, MuiTypography } from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import {
  DestinationProgram,
  ProgramDetail,
} from "../../../createProgram/modelsAndSchemas/Models";
import { transferProgramDetailsSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { TransferProgramDetailsWrapper } from "./TransferProgramDetails.style";

interface TransferProgramDetailsProps {
  pageId: string;
  sourceProgramData?: Partial<ProgramDetail>;
  destinationProgramData?: DestinationProgram;
  isNoDestinationTemplate?: boolean;
  showDeliveryOffice?: boolean;
  isTransferToCountry: boolean;
}

export const TransferProgramDetails: FC<TransferProgramDetailsProps> = ({
  pageId,
  sourceProgramData,
  destinationProgramData,
  isNoDestinationTemplate,
  showDeliveryOffice,
  isTransferToCountry,
}) => {
  const { fetchLabel } = useSiteCore();

  const getLabel = (key: string) => {
    return fetchLabel(
      transferProgramDetailsSiteCoreKeys.transferDetailsKey,
      key,
    );
  };
  return (
    <TransferProgramDetailsWrapper>
      <MuiBox className="transfer-container transfer-container-bulk">
        <MuiBox className="transfer-box">
          <MuiTypography variant="h2SemiBold" className="source-program-label">
            {getLabel(transferProgramDetailsSiteCoreKeys.sourceProgram)}
          </MuiTypography>
          <MuiDoubleLabel
            label={getLabel(transferProgramDetailsSiteCoreKeys.sourceCountry)}
            value={sourceProgramData?.deliveryCountryName}
            isValueWithEllipsis
            replaceEmptyWithDash
            className="source-program-container"
          />
          {showDeliveryOffice && (
            <MuiDoubleLabel
              label={getLabel(
                transferProgramDetailsSiteCoreKeys.deliveryOffice,
              )}
              value={sourceProgramData?.deliveryOffice}
              isValueWithEllipsis
              replaceEmptyWithDash
              className="source-program-container source-delivery-office"
            />
          )}
          {/* skipped for now BE is to confirm response, but added label with empty value for design mismatch */}
          {isTransferToCountry && (
            <MuiDoubleLabel
              label={getLabel(transferProgramDetailsSiteCoreKeys.nextLanguage)}
              value={""} //change key here once we have confirmation
              isValueWithEllipsis
              replaceEmptyWithDash
              className="source-program-container"
            />
          )}
          <MuiDoubleLabel
            label={getLabel(transferProgramDetailsSiteCoreKeys.nextView)}
            value={sourceProgramData?.solutionOffering}
            isValueWithEllipsis
            replaceEmptyWithDash
            className="source-program-container"
          />
          <MuiDoubleLabel
            label={getLabel(transferProgramDetailsSiteCoreKeys.programTemplate)}
            value={sourceProgramData?.programTemplate}
            isValueWithEllipsis
            replaceEmptyWithDash
            className="source-program-container"
          />
        </MuiBox>
        <ArrowCircleRightOutlinedIcon className="arrow-icon" />
        <MuiBox className="transfer-box">
          <MuiTypography variant="h2SemiBold" className="source-program-label">
            {getLabel(transferProgramDetailsSiteCoreKeys.destinationProgram)}
          </MuiTypography>
          <MuiDoubleLabel
            label={getLabel(
              transferProgramDetailsSiteCoreKeys.destinationCountry,
            )}
            value={destinationProgramData?.destination?.countryName}
            isValueWithEllipsis
            replaceEmptyWithDash
            className="source-program-container"
          />
          {showDeliveryOffice && (
            <MuiDoubleLabel
              label={getLabel(
                transferProgramDetailsSiteCoreKeys.deliveryOffice,
              )}
              value={destinationProgramData?.deliveryOffice?.countryName}
              isValueWithEllipsis
              replaceEmptyWithDash
              className="source-program-container"
            />
          )}
          {isTransferToCountry && (
            <MuiDoubleLabel
              label={getLabel(transferProgramDetailsSiteCoreKeys.nextLanguage)}
              value={destinationProgramData?.selectedNextLanguage}
              isValueWithEllipsis
              replaceEmptyWithDash
              className="source-program-container"
            />
          )}
          <MuiDoubleLabel
            label={getLabel(transferProgramDetailsSiteCoreKeys.nextView)}
            value={destinationProgramData?.solutionOfferings?.name}
            isValueWithEllipsis
            replaceEmptyWithDash
            className="source-program-container"
          />
          <MuiDoubleLabel
            label={getLabel(
              transferProgramDetailsSiteCoreKeys.compatibleProgramTemplate,
            )}
            labelIcon={isNoDestinationTemplate && <WarningIcon />}
            value={
              isNoDestinationTemplate
                ? getLabel(
                    transferProgramDetailsSiteCoreKeys.noTemplateAvailable,
                  )
                : destinationProgramData?.compatibleProgramTemplate?.name
            }
            isValueWithEllipsis
            replaceEmptyWithDash
            className="source-program-container"
          />
        </MuiBox>
      </MuiBox>
    </TransferProgramDetailsWrapper>
  );
};
